import { VEHICLE_DROPDOWN_QUERY } from "@app/shared/fleet/vehicle/queries/vehicle-dropdown.query";

/** Display-time vehicle facts shared by the block form and detail preview; never persisted on a block. */
export const VEHICLE_BLOCK_VEHICLE_QUERY = `
  ${VEHICLE_DROPDOWN_QUERY}
  realtime {
    currentKm
    assignedLocation { id locationName }
  }
  vehicleSpecifications {
    fuels { capacity currentLevel fuelType { unit } }
  }
`;
